import CheckoutApi from '@support/checkoutApi'
import _ from "lodash";
import Axios from "axios";

const _shipping = (context, params) => {
    const {service_code, package_code} = context.rootState.shipping;
    const setLoadingShippingMethods = status => context.commit('checkout/setLoadingShippingMethods', status, {root: true});
    const setShippingMethods = methods => context.commit('setShippingMethods', methods);
    const changeSelectedShippingMethod = method => context.dispatch('setSelectedShippingMethod', method);
    const resetShippingMethod = () => {
        changeSelectedShippingMethod(null);
        context.commit('shipping/setServiceCode', '', {root: true});
        context.commit('shipping/setPackageCode', '', {root: true});
    };

    setLoadingShippingMethods(true);

    return CheckoutApi.getShipping(params).then((response) => {
        setShippingMethods(response.data.data || []);

        const shippingMethods = context.state.shipping_methods;

        if (service_code && package_code && shippingMethods.length) {
            const currentShippingMethod = _.find(shippingMethods, {package_code, service_code})
                || _.head(shippingMethods);

            console.debug('Update current shipping method');
            console.table([currentShippingMethod]);

            if (currentShippingMethod) {
                changeSelectedShippingMethod(currentShippingMethod);
            } else {
                resetShippingMethod();
            }
        } else if (shippingMethods.length) {
            console.log('Set first shipping method');
            changeSelectedShippingMethod(_.head(shippingMethods));
        } else {
            console.log('Reset shipping method');
            resetShippingMethod();
        }

        return response;
    }).catch(err => {
        setShippingMethods([]);


      if (err.response?.status === 400 && err.response?.data?.type === 'exceed-limits') {
        console.error(err)
        return new Promise(resolve => setTimeout(() => _shipping(context, params).then(resolve), 2000))
      }

      return err;
    }).then(r => {
      if (r instanceof Axios.Cancel) { return r; }

      setLoadingShippingMethods(false);
      return r;
    });
}
export const shipping = _.debounce(_shipping, 2000);
export const fast_shipping = _shipping

const _taxes = (context) => {
    const shipping = context.rootState.shipping;
    const setLoadingTaxes = status => context.commit('setLoadingTaxes', status);
    const setIsTaxesCalculatedStatus = status => context.commit('setTaxesCalculated', status);

    setLoadingTaxes(true);
    setIsTaxesCalculatedStatus(false);

    CheckoutApi.calculateTaxes(shipping).then((response) => {
        console.log('taxes calculated');
        const prevProducts = context.state?.obj?.products

        context.dispatch('updateCheckout', {
          ...response.data,
          products: prevProducts || response.data.products
        }, {root: true});
        setIsTaxesCalculatedStatus(true);
    }).catch((error) => {
        console.error(error);
    }).then(() => setLoadingTaxes(false));
}
export const taxes = _.debounce(_taxes, 500);
